exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar-uploader .el-upload {\n  border-radius: 0.03125rem;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  border: 0.005208rem dashed #ddd;\n}\n.avatar-uploader .el-upload:hover {\n  border-color: #409eff;\n}\n.avatar-uploader .el-upload:hover .avatar-uploader-icon {\n  color: #409eff;\n}\n.avatar-uploader-icon {\n  font-size: 0.145833rem;\n  color: #8c939d;\n  line-height: 0.927083rem;\n  text-align: center;\n  transition: all 0.2s linear;\n}\n.avatar {\n  display: block;\n}", ""]);

// exports
